var map = {
	"./App": 40642,
	"./App.vue": 40642,
	"./assets/css/anim.scss": 2791,
	"./assets/css/common.scss": 26646,
	"./assets/css/global.scss": 70656,
	"./assets/css/loading.scss": 26950,
	"./assets/css/reset.scss": 64410,
	"./assets/css/utils.scss": 76906,
	"./assets/fonts/AHKIO LIGHT.OTF": 21821,
	"./assets/fonts/HARMONYOS_SANS_BOLD.TTF": 35981,
	"./assets/fonts/HARMONYOS_SANS_MEDIUM.TTF": 14514,
	"./assets/fonts/HARMONYOS_SANS_REGULAR.TTF": 39773,
	"./assets/fonts/font.css": 7903,
	"./assets/icons": 17258,
	"./assets/icons/": 17258,
	"./assets/icons/index": 17258,
	"./assets/icons/index.js": 17258,
	"./assets/icons/svg/icon-arrow.svg": 51089,
	"./assets/icons/svg/icon-close.svg": 50829,
	"./assets/icons/svg/icon-copy.svg": 54171,
	"./assets/icons/svg/icon-edit.svg": 47766,
	"./assets/icons/svg/icon-lfg.svg": 54012,
	"./assets/icons/svg/icon-lock.svg": 20111,
	"./assets/icons/svg/icon-log.svg": 90943,
	"./assets/icons/svg/icon-ok.svg": 35686,
	"./assets/icons/svg/icon-quest.svg": 62711,
	"./assets/icons/svg/icon-refresh.svg": 82037,
	"./assets/icons/svg/icon-refresh2.svg": 44627,
	"./assets/icons/svg/icon-rightarrow.svg": 90883,
	"./assets/icons/svg/icon-share.svg": 71820,
	"./assets/icons/svg/icon-sigh.svg": 34383,
	"./assets/icons/svg/icon-telegram.svg": 45810,
	"./assets/icons/svg/icon-user.svg": 8639,
	"./assets/images/tapcoin/30tip.png": 85750,
	"./assets/images/tapcoin/BIGTON.png": 92775,
	"./assets/images/tapcoin/TONwallet.png": 1280,
	"./assets/images/tapcoin/activity-top.png": 81522,
	"./assets/images/tapcoin/airdrop-big.png": 86780,
	"./assets/images/tapcoin/airdrop-channel.png": 85745,
	"./assets/images/tapcoin/airdrop-freemint.png": 44746,
	"./assets/images/tapcoin/airdrop-icons.png": 92227,
	"./assets/images/tapcoin/airdrop-left-bg.jpg": 67310,
	"./assets/images/tapcoin/airdrop-ok.png": 2664,
	"./assets/images/tapcoin/airdrop-pass.png": 64079,
	"./assets/images/tapcoin/airdrop-right-bg.jpg": 78149,
	"./assets/images/tapcoin/airdrop-tap-icon1.png": 65994,
	"./assets/images/tapcoin/airdrop-tap-icon2.png": 43121,
	"./assets/images/tapcoin/airdrop-tap-icon3.png": 57056,
	"./assets/images/tapcoin/airdrop-tap-icon4.png": 86026,
	"./assets/images/tapcoin/airdrop-tap-icon5.png": 48587,
	"./assets/images/tapcoin/airdrop-tap-icon6.png": 75609,
	"./assets/images/tapcoin/airdrop-tap-r2-icon1.png": 85316,
	"./assets/images/tapcoin/airdrop-tap-r2-icon10.png": 96393,
	"./assets/images/tapcoin/airdrop-tap-r2-icon2.png": 50368,
	"./assets/images/tapcoin/airdrop-tap-r2-icon3.png": 7814,
	"./assets/images/tapcoin/airdrop-tap-r2-icon4.png": 69763,
	"./assets/images/tapcoin/airdrop-tap-r2-icon5.png": 77241,
	"./assets/images/tapcoin/airdrop-tap-r2-icon6.png": 84846,
	"./assets/images/tapcoin/airdrop-tap-r2-icon7.png": 94372,
	"./assets/images/tapcoin/airdrop-tap-r2-icon8.png": 97645,
	"./assets/images/tapcoin/airdrop-tap-r2-icon9.png": 24860,
	"./assets/images/tapcoin/airdrop-tickets.png": 74318,
	"./assets/images/tapcoin/airdrop-top-bg.png": 59515,
	"./assets/images/tapcoin/airdrop-wallet.png": 70284,
	"./assets/images/tapcoin/airdrop.png": 73971,
	"./assets/images/tapcoin/award.png": 78171,
	"./assets/images/tapcoin/award_tip.jpg": 35234,
	"./assets/images/tapcoin/bitget.jpg": 1329,
	"./assets/images/tapcoin/bnb_logo.png": 62243,
	"./assets/images/tapcoin/boost-list-icon-1.png": 15035,
	"./assets/images/tapcoin/boost-list-icon-2.png": 72043,
	"./assets/images/tapcoin/boost-list-icon-3.png": 43444,
	"./assets/images/tapcoin/boost-list-icon-4.png": 4681,
	"./assets/images/tapcoin/boost-list-icon-5.png": 67241,
	"./assets/images/tapcoin/boost-list-icon-6.png": 2970,
	"./assets/images/tapcoin/browser.png": 22461,
	"./assets/images/tapcoin/btn-icon-boost.png": 97498,
	"./assets/images/tapcoin/btn-icon-frens.png": 39246,
	"./assets/images/tapcoin/code-icon-0.png": 2913,
	"./assets/images/tapcoin/daily-invite.png": 49729,
	"./assets/images/tapcoin/daily_icon.png": 29094,
	"./assets/images/tapcoin/diamond.png": 97669,
	"./assets/images/tapcoin/earn-btn-bg.jpg": 55343,
	"./assets/images/tapcoin/earn-head-icon-gift.png": 59216,
	"./assets/images/tapcoin/earn-icon-0.png": 43847,
	"./assets/images/tapcoin/earn-key.png": 50899,
	"./assets/images/tapcoin/earn-list-icon-1.png": 349,
	"./assets/images/tapcoin/earn-list-icon-2.png": 45090,
	"./assets/images/tapcoin/earn-list-icon-gift.png": 95596,
	"./assets/images/tapcoin/earn-logo.png": 44577,
	"./assets/images/tapcoin/finish.png": 26059,
	"./assets/images/tapcoin/frens-1.png": 44604,
	"./assets/images/tapcoin/frens-2.png": 32854,
	"./assets/images/tapcoin/frens-3.png": 28306,
	"./assets/images/tapcoin/gate.jpg": 94279,
	"./assets/images/tapcoin/icon-frens.png": 93011,
	"./assets/images/tapcoin/icon-pph-1.png": 37825,
	"./assets/images/tapcoin/icon-pph-2.png": 42220,
	"./assets/images/tapcoin/index-bg-1.jpg": 62848,
	"./assets/images/tapcoin/index-bg.jpg": 63156,
	"./assets/images/tapcoin/index-btn-activity.png": 76101,
	"./assets/images/tapcoin/index-btn-airdrop.png": 21553,
	"./assets/images/tapcoin/index-btn-appcenter.png": 22110,
	"./assets/images/tapcoin/index-btn-boost.png": 30586,
	"./assets/images/tapcoin/index-btn-earn.png": 3263,
	"./assets/images/tapcoin/index-btn-frens.png": 94744,
	"./assets/images/tapcoin/index-btn-home.png": 20638,
	"./assets/images/tapcoin/index-btn-icon-1.png": 36013,
	"./assets/images/tapcoin/index-btn-icon-2.png": 7031,
	"./assets/images/tapcoin/index-btn-icon-21.png": 12586,
	"./assets/images/tapcoin/index-btn-icon-3.png": 64551,
	"./assets/images/tapcoin/index-btn-icon-4.png": 66708,
	"./assets/images/tapcoin/index-btn-lottery.png": 95357,
	"./assets/images/tapcoin/index-btn-mine.png": 6368,
	"./assets/images/tapcoin/index-btn-wallet.png": 46198,
	"./assets/images/tapcoin/index-c-btn-bg.png": 80124,
	"./assets/images/tapcoin/index-icon-big-coin.png": 57569,
	"./assets/images/tapcoin/index-icon-bronze.png": 45580,
	"./assets/images/tapcoin/index-icon-energy.png": 58052,
	"./assets/images/tapcoin/index-icon-level.png": 75009,
	"./assets/images/tapcoin/index-icon-pph.png": 76938,
	"./assets/images/tapcoin/index-icon-small-coin.png": 68841,
	"./assets/images/tapcoin/index-icon-squad-1.png": 98556,
	"./assets/images/tapcoin/index-icon-squad.png": 21273,
	"./assets/images/tapcoin/index-icon-wallet.png": 82472,
	"./assets/images/tapcoin/inset-bg-1.jpg": 88991,
	"./assets/images/tapcoin/inset-bg.jpg": 62836,
	"./assets/images/tapcoin/join-icon-frens.png": 25786,
	"./assets/images/tapcoin/lbank.jpg": 87678,
	"./assets/images/tapcoin/level/Bronze.png": 81649,
	"./assets/images/tapcoin/level/Diamond.png": 17308,
	"./assets/images/tapcoin/level/Emerald.png": 39975,
	"./assets/images/tapcoin/level/Gold.png": 88027,
	"./assets/images/tapcoin/level/Platinum.png": 96604,
	"./assets/images/tapcoin/level/Ruby.png": 29676,
	"./assets/images/tapcoin/level/Silver.png": 97004,
	"./assets/images/tapcoin/level/Wish.png": 85792,
	"./assets/images/tapcoin/loading.gif": 28272,
	"./assets/images/tapcoin/lock.png": 72193,
	"./assets/images/tapcoin/logo.png": 94623,
	"./assets/images/tapcoin/lottery-icon.png": 55375,
	"./assets/images/tapcoin/luckcode.png": 49349,
	"./assets/images/tapcoin/lucky/key.png": 64765,
	"./assets/images/tapcoin/lucky/light1.png": 94421,
	"./assets/images/tapcoin/lucky/light2.png": 73133,
	"./assets/images/tapcoin/lucky/lucky-bg.jpg": 85774,
	"./assets/images/tapcoin/lucky/lucky-btn-bg.png": 2548,
	"./assets/images/tapcoin/lucky/lucky-item-bg.png": 48012,
	"./assets/images/tapcoin/lucky/lucky-result-coin-tap.png": 55788,
	"./assets/images/tapcoin/lucky/lucky-result-coin-tapcoins.png": 16414,
	"./assets/images/tapcoin/lucky/lucky-result-coin-tapstock.png": 43375,
	"./assets/images/tapcoin/lucky/lucky-result-coin-ton.png": 82649,
	"./assets/images/tapcoin/lucky/lucky-result-coin-usdt.png": 11104,
	"./assets/images/tapcoin/lucky/lucky-result-light.png": 60268,
	"./assets/images/tapcoin/lucky/tap.png": 35092,
	"./assets/images/tapcoin/lucky/tapcoins.png": 78565,
	"./assets/images/tapcoin/lucky/ton.png": 52808,
	"./assets/images/tapcoin/lucky/usdt.png": 5976,
	"./assets/images/tapcoin/luckybox/bought-bg.png": 77765,
	"./assets/images/tapcoin/luckybox/box/1.png": 74891,
	"./assets/images/tapcoin/luckybox/box/11.png": 30398,
	"./assets/images/tapcoin/luckybox/box/2.png": 59330,
	"./assets/images/tapcoin/luckybox/box/21.png": 87336,
	"./assets/images/tapcoin/luckybox/box/3.png": 11363,
	"./assets/images/tapcoin/luckybox/box/31.png": 16370,
	"./assets/images/tapcoin/luckybox/box/4.png": 1188,
	"./assets/images/tapcoin/luckybox/box/41.png": 85447,
	"./assets/images/tapcoin/luckybox/box/5.png": 92037,
	"./assets/images/tapcoin/luckybox/box/51.png": 51508,
	"./assets/images/tapcoin/luckybox/box/6.png": 21910,
	"./assets/images/tapcoin/luckybox/box/61.png": 90135,
	"./assets/images/tapcoin/luckybox/leaderboard.png": 32395,
	"./assets/images/tapcoin/luckybox/luckybox-hd.png": 76390,
	"./assets/images/tapcoin/luckybox/luckybox-hd1.png": 81015,
	"./assets/images/tapcoin/luckybox/luckybox-item-bg.png": 39889,
	"./assets/images/tapcoin/luckybox/records.png": 2017,
	"./assets/images/tapcoin/menu-bg.png": 5620,
	"./assets/images/tapcoin/mexc.jpg": 95897,
	"./assets/images/tapcoin/new/30tip.png": 10411,
	"./assets/images/tapcoin/new/CRY.png": 61764,
	"./assets/images/tapcoin/new/TAP-small.png": 24460,
	"./assets/images/tapcoin/new/TAP.png": 63297,
	"./assets/images/tapcoin/new/TAPCOINS-small.png": 9474,
	"./assets/images/tapcoin/new/TAPCOINS.png": 12129,
	"./assets/images/tapcoin/new/TAPSTOCK-small.png": 12337,
	"./assets/images/tapcoin/new/TAPSTOCK.png": 68715,
	"./assets/images/tapcoin/new/TON.png": 5418,
	"./assets/images/tapcoin/new/USDT-small.png": 4943,
	"./assets/images/tapcoin/new/USDT.png": 56595,
	"./assets/images/tapcoin/new/avatar/avatar-1.png": 24774,
	"./assets/images/tapcoin/new/avatar/avatar-2.png": 93337,
	"./assets/images/tapcoin/new/avatar/avatar-3.png": 2025,
	"./assets/images/tapcoin/new/avatar/avatar-4.png": 28018,
	"./assets/images/tapcoin/new/avatar/avatar-5.png": 25571,
	"./assets/images/tapcoin/new/avatar/index-bg-basic.jpg": 24435,
	"./assets/images/tapcoin/new/avatar/index-bg-basic1.jpg": 8801,
	"./assets/images/tapcoin/new/avatar/index-bg-basic2.jpg": 26331,
	"./assets/images/tapcoin/new/blind/bind-box.png": 16670,
	"./assets/images/tapcoin/new/blind/bind-item-bg.jpg": 67404,
	"./assets/images/tapcoin/new/blind/bind-select.png": 31329,
	"./assets/images/tapcoin/new/blind/blind-container-bg.png": 65899,
	"./assets/images/tapcoin/new/blind/blind-items-board.png": 29146,
	"./assets/images/tapcoin/new/blind/reward-box.png": 39264,
	"./assets/images/tapcoin/new/blind/reward-select.png": 6608,
	"./assets/images/tapcoin/new/btn-scan.jpg": 77336,
	"./assets/images/tapcoin/new/gift-selector-arrow.png": 53981,
	"./assets/images/tapcoin/new/gift-selector.png": 21226,
	"./assets/images/tapcoin/new/gift/gift-exclusise-img.png": 89505,
	"./assets/images/tapcoin/new/gift/gift-high-img.png": 11073,
	"./assets/images/tapcoin/new/gift/gift-img.jpg": 70129,
	"./assets/images/tapcoin/new/hot.png": 3785,
	"./assets/images/tapcoin/new/icon-diamond.png": 93365,
	"./assets/images/tapcoin/new/icon-gold-1.png": 22444,
	"./assets/images/tapcoin/new/icon-group.png": 76515,
	"./assets/images/tapcoin/new/icon-menu.png": 70354,
	"./assets/images/tapcoin/new/icon-ok.png": 37674,
	"./assets/images/tapcoin/new/icon-profit.png": 67918,
	"./assets/images/tapcoin/new/icon-ranking.png": 98853,
	"./assets/images/tapcoin/new/icon-wallet.png": 16864,
	"./assets/images/tapcoin/new/index-bg-gold.png": 33292,
	"./assets/images/tapcoin/new/index-icon-boosts.png": 38663,
	"./assets/images/tapcoin/new/index-icon-crypto.png": 91607,
	"./assets/images/tapcoin/new/index-icon-frens.png": 67993,
	"./assets/images/tapcoin/new/index-icon-progress.png": 59021,
	"./assets/images/tapcoin/new/index-icon-slots.png": 4282,
	"./assets/images/tapcoin/new/index-icon-spin.png": 50241,
	"./assets/images/tapcoin/new/lock/avatar-lock-bg.jpg": 92930,
	"./assets/images/tapcoin/new/lock/avatar-lock-l.png": 76149,
	"./assets/images/tapcoin/new/lock/avatar-lock-s.png": 5386,
	"./assets/images/tapcoin/new/lock/double_p.png": 45844,
	"./assets/images/tapcoin/new/lock/gift-1.png": 43010,
	"./assets/images/tapcoin/new/lock/gift-2.png": 69894,
	"./assets/images/tapcoin/new/lock/gift-3.png": 37356,
	"./assets/images/tapcoin/new/machine/machine-arrow.png": 17336,
	"./assets/images/tapcoin/new/machine/machine-bg.png": 5455,
	"./assets/images/tapcoin/new/machine/machine-btn1-bg-1.png": 29058,
	"./assets/images/tapcoin/new/machine/machine-btn1-bg.png": 87662,
	"./assets/images/tapcoin/new/machine/machine-btn2-bg-1.png": 73990,
	"./assets/images/tapcoin/new/machine/machine-btn2-bg.png": 60726,
	"./assets/images/tapcoin/new/machine/machine-main-bg.png": 92956,
	"./assets/images/tapcoin/new/machine/machine-page-bg.jpg": 13637,
	"./assets/images/tapcoin/new/machine/machine-title.png": 39551,
	"./assets/images/tapcoin/new/menu-active-bg.png": 36962,
	"./assets/images/tapcoin/new/menu-airdrop-active.png": 84387,
	"./assets/images/tapcoin/new/menu-airdrop.png": 19842,
	"./assets/images/tapcoin/new/menu-app-active.png": 2627,
	"./assets/images/tapcoin/new/menu-app.png": 93024,
	"./assets/images/tapcoin/new/menu-bg.png": 48030,
	"./assets/images/tapcoin/new/menu-earn-active.png": 35656,
	"./assets/images/tapcoin/new/menu-earn.png": 78194,
	"./assets/images/tapcoin/new/menu-gift-active.png": 10321,
	"./assets/images/tapcoin/new/menu-gift.png": 47003,
	"./assets/images/tapcoin/new/menu-home-active.png": 11681,
	"./assets/images/tapcoin/new/menu-home.png": 30399,
	"./assets/images/tapcoin/new/menu-study-active.png": 63565,
	"./assets/images/tapcoin/new/menu-study.png": 53568,
	"./assets/images/tapcoin/new/menu-tasks-active.png": 27283,
	"./assets/images/tapcoin/new/menu-tasks.png": 23570,
	"./assets/images/tapcoin/new/nav-bg.jpg": 77843,
	"./assets/images/tapcoin/new/nav-icon-achievements.png": 96289,
	"./assets/images/tapcoin/new/nav-icon-bounty.png": 18689,
	"./assets/images/tapcoin/new/nav-icon-code.png": 4169,
	"./assets/images/tapcoin/new/nav-icon-login.png": 82097,
	"./assets/images/tapcoin/new/new.png": 76794,
	"./assets/images/tapcoin/new/niceLucky/btn-1.png": 70699,
	"./assets/images/tapcoin/new/niceLucky/btn-2.png": 72564,
	"./assets/images/tapcoin/new/niceLucky/icon-buy.png": 77947,
	"./assets/images/tapcoin/new/niceLucky/icon-invite.png": 15850,
	"./assets/images/tapcoin/new/niceLucky/icon-shard.png": 82170,
	"./assets/images/tapcoin/new/niceLucky/icon-ship.png": 54684,
	"./assets/images/tapcoin/new/niceLucky/icon-task.png": 53731,
	"./assets/images/tapcoin/new/niceLucky/light.png": 22540,
	"./assets/images/tapcoin/new/niceLucky/nft-bg.jpg": 74418,
	"./assets/images/tapcoin/new/niceLucky/niceLucky-bottom.png": 52706,
	"./assets/images/tapcoin/new/niceLucky/niceLucky-item-active-bg.png": 26666,
	"./assets/images/tapcoin/new/niceLucky/niceLucky-item-bg.png": 53468,
	"./assets/images/tapcoin/new/niceLucky/niceLucky.png": 13243,
	"./assets/images/tapcoin/new/niceLucky/niceLucky_title.png": 2036,
	"./assets/images/tapcoin/new/niceLucky/niceLucy-bg.jpg": 57808,
	"./assets/images/tapcoin/new/niceLucky/ship-num.png": 42450,
	"./assets/images/tapcoin/new/perHour.png": 88043,
	"./assets/images/tapcoin/okwallet-logo.png": 36863,
	"./assets/images/tapcoin/okx.jpg": 38297,
	"./assets/images/tapcoin/okxwallet-live.png": 52338,
	"./assets/images/tapcoin/okxwallet-top.png": 19501,
	"./assets/images/tapcoin/pop-award-icon-0.png": 79986,
	"./assets/images/tapcoin/pop-coin-hero-icon-0.png": 63230,
	"./assets/images/tapcoin/pop-up-gold-icon-0.png": 9611,
	"./assets/images/tapcoin/premium-s.png": 93685,
	"./assets/images/tapcoin/premium.png": 69018,
	"./assets/images/tapcoin/proof.jpg": 29206,
	"./assets/images/tapcoin/rank-1.png": 19162,
	"./assets/images/tapcoin/rank-2.png": 32030,
	"./assets/images/tapcoin/rank-3.png": 78368,
	"./assets/images/tapcoin/rank-bronze.png": 44222,
	"./assets/images/tapcoin/robot-logo.jpg": 52541,
	"./assets/images/tapcoin/scan-head.jpg": 40072,
	"./assets/images/tapcoin/sd.png": 18773,
	"./assets/images/tapcoin/sign-calendar-ok.png": 36468,
	"./assets/images/tapcoin/sign-calendar.png": 18976,
	"./assets/images/tapcoin/sign-premium.png": 96936,
	"./assets/images/tapcoin/solojack-tip.png": 57211,
	"./assets/images/tapcoin/squad-icon-1.png": 54583,
	"./assets/images/tapcoin/squad-icon-2.png": 44481,
	"./assets/images/tapcoin/squad-icon-3.png": 3355,
	"./assets/images/tapcoin/squad-icon-4.png": 83051,
	"./assets/images/tapcoin/start.png": 8059,
	"./assets/images/tapcoin/tap.png": 30909,
	"./assets/images/tapcoin/task-detail-arrow.png": 50056,
	"./assets/images/tapcoin/task-detail-arrow2.png": 88161,
	"./assets/images/tapcoin/task-detail-bg.jpg": 68183,
	"./assets/images/tapcoin/task-detail-step-1.jpg": 82173,
	"./assets/images/tapcoin/task-detail-step-2.jpg": 50133,
	"./assets/images/tapcoin/task-detail-step-3.jpg": 4134,
	"./assets/images/tapcoin/task-detail-step-4.jpg": 26725,
	"./assets/images/tapcoin/tickets.png": 73780,
	"./assets/images/tapcoin/time.png": 92661,
	"./assets/images/tapcoin/tip.png": 62136,
	"./assets/images/tapcoin/ton-add.png": 5929,
	"./assets/images/tapcoin/ton-stars.png": 92550,
	"./assets/images/tapcoin/tron.png": 89486,
	"./assets/images/tapcoin/turbo.png": 11278,
	"./assets/images/tapcoin/unknown.png": 70001,
	"./assets/images/tapcoin/up.png": 570,
	"./assets/images/tapcoin/usdt-p.png": 65984,
	"./assets/images/tapcoin/usdt.png": 44777,
	"./assets/images/tapcoin/zbx.jpg": 78155,
	"./assets/js/assetsManifest": 55715,
	"./assets/js/assetsManifest.json": 55715,
	"./assets/js/confetti": 19342,
	"./assets/js/confetti.js": 19342,
	"./assets/js/fireworkEffect": 83034,
	"./assets/js/fireworkEffect.js": 83034,
	"./assets/js/hoejs": 63964,
	"./assets/js/hoejs.js": 63964,
	"./assets/js/noZoom": 62654,
	"./assets/js/noZoom.js": 62654,
	"./assets/js/pop": 42487,
	"./assets/js/pop.js": 42487,
	"./assets/js/rem": 79633,
	"./assets/js/rem.js": 79633,
	"./components/btnBack": 71116,
	"./components/btnBack.vue": 71116,
	"./components/carousel/carousel": 78520,
	"./components/carousel/carousel.vue": 78520,
	"./components/countUp": 9058,
	"./components/countUp.vue": 9058,
	"./components/index/goldcoinIndex": 2641,
	"./components/index/goldcoinIndex.vue": 2641,
	"./components/index/memetownIndex": 71596,
	"./components/index/memetownIndex.vue": 71596,
	"./components/index/reflectionIndex": 10351,
	"./components/index/reflectionIndex.vue": 10351,
	"./components/index/tapcoinIndex": 27890,
	"./components/index/tapcoinIndex.vue": 27890,
	"./components/index/tapcoinIndexNew": 70372,
	"./components/index/tapcoinIndexNew.vue": 70372,
	"./components/layout": 1386,
	"./components/layout.vue": 1386,
	"./components/luckywheel/luckyWheel": 98406,
	"./components/luckywheel/luckyWheel.vue": 98406,
	"./components/luckywheel/luckyWheelItem": 19537,
	"./components/luckywheel/luckyWheelItem.vue": 19537,
	"./components/mHead": 68623,
	"./components/mHead.vue": 68623,
	"./components/mMenu": 13439,
	"./components/mMenu.vue": 13439,
	"./components/mPage": 41875,
	"./components/mPage.vue": 41875,
	"./components/myLoading": 59478,
	"./components/myLoading/": 59478,
	"./components/myLoading/index": 59478,
	"./components/myLoading/index.js": 59478,
	"./components/myLoading/myLoading": 12229,
	"./components/myLoading/myLoading.scss": 40735,
	"./components/myLoading/myLoading.vue": 12229,
	"./components/myTile/myTile": 1308,
	"./components/myTile/myTile.vue": 1308,
	"./components/myTile/vanilla-tilt": 81043,
	"./components/myTile/vanilla-tilt.js": 81043,
	"./components/popAchievements": 710,
	"./components/popAchievements.vue": 710,
	"./components/popAdvTip": 28652,
	"./components/popAdvTip.vue": 28652,
	"./components/popAirdropTapLogs": 71612,
	"./components/popAirdropTapLogs.vue": 71612,
	"./components/popAirdropTapTip": 4274,
	"./components/popAirdropTapTip.vue": 4274,
	"./components/popAirdropTicketDesc": 93865,
	"./components/popAirdropTicketDesc.vue": 93865,
	"./components/popAirdropTicketLogs": 71484,
	"./components/popAirdropTicketLogs.vue": 71484,
	"./components/popAirdropTicketTip": 46178,
	"./components/popAirdropTicketTip.vue": 46178,
	"./components/popAirdropTip": 69313,
	"./components/popAirdropTip.vue": 69313,
	"./components/popAppcenterEnergy": 16918,
	"./components/popAppcenterEnergy.vue": 16918,
	"./components/popAppcenterTipEnergy": 47106,
	"./components/popAppcenterTipEnergy.vue": 47106,
	"./components/popAward": 36429,
	"./components/popAward.vue": 36429,
	"./components/popAwardTip": 5802,
	"./components/popAwardTip.vue": 5802,
	"./components/popBindOkxWallet": 29973,
	"./components/popBindOkxWallet.vue": 29973,
	"./components/popBindWallet": 8060,
	"./components/popBindWallet.vue": 8060,
	"./components/popBioMatrixScan": 6054,
	"./components/popBioMatrixScan.vue": 6054,
	"./components/popBioMatrixScanCheck": 5262,
	"./components/popBioMatrixScanCheck.vue": 5262,
	"./components/popBioMatrixScanNext": 40981,
	"./components/popBioMatrixScanNext.vue": 40981,
	"./components/popBioMatrixScanReward": 86649,
	"./components/popBioMatrixScanReward.vue": 86649,
	"./components/popBitgetUidSubmit": 93878,
	"./components/popBitgetUidSubmit.vue": 93878,
	"./components/popCodexFieldWallet": 55422,
	"./components/popCodexFieldWallet.vue": 55422,
	"./components/popCoinHero": 77861,
	"./components/popCoinHero.vue": 77861,
	"./components/popDialog": 73051,
	"./components/popDialog.vue": 73051,
	"./components/popEarnTip": 86036,
	"./components/popEarnTip.vue": 86036,
	"./components/popEnergy": 40517,
	"./components/popEnergy.vue": 40517,
	"./components/popExtraInvite": 57161,
	"./components/popExtraInvite.vue": 57161,
	"./components/popFaceScan": 10176,
	"./components/popFaceScan.vue": 10176,
	"./components/popFaceScanLog": 69095,
	"./components/popFaceScanLog.vue": 69095,
	"./components/popFaceTip": 8264,
	"./components/popFaceTip.vue": 8264,
	"./components/popGetAward": 58089,
	"./components/popGetAward.vue": 58089,
	"./components/popGetRewardTip": 37108,
	"./components/popGetRewardTip.vue": 37108,
	"./components/popJoin": 93886,
	"./components/popJoin.vue": 93886,
	"./components/popLoginReward": 92233,
	"./components/popLoginReward.vue": 92233,
	"./components/popLotteryJoin": 48422,
	"./components/popLotteryJoin.vue": 48422,
	"./components/popLuckyboxDiamond": 975,
	"./components/popLuckyboxDiamond.vue": 975,
	"./components/popLuckyboxNewRound": 5529,
	"./components/popLuckyboxNewRound.vue": 5529,
	"./components/popLuckyboxNewTip": 75838,
	"./components/popLuckyboxNewTip.vue": 75838,
	"./components/popLuckyboxRanking": 32287,
	"./components/popLuckyboxRanking.vue": 32287,
	"./components/popLuckyboxRecords": 37422,
	"./components/popLuckyboxRecords.vue": 37422,
	"./components/popLuckyboxRecordsInfo": 44886,
	"./components/popLuckyboxRecordsInfo.vue": 44886,
	"./components/popLuckyboxTip": 10067,
	"./components/popLuckyboxTip.vue": 10067,
	"./components/popMethod": 91574,
	"./components/popMethod.vue": 91574,
	"./components/popMineEnergy": 58939,
	"./components/popMineEnergy.vue": 58939,
	"./components/popMineTip": 66767,
	"./components/popMineTip.vue": 66767,
	"./components/popPphTip": 6961,
	"./components/popPphTip.vue": 6961,
	"./components/popPrompt": 42702,
	"./components/popPrompt.vue": 42702,
	"./components/popRewardResult": 12204,
	"./components/popRewardResult.vue": 12204,
	"./components/popRobot": 4972,
	"./components/popRobot.vue": 4972,
	"./components/popSelectToken": 6048,
	"./components/popSelectToken.vue": 6048,
	"./components/popSellGift": 46536,
	"./components/popSellGift.vue": 46536,
	"./components/popShare": 52891,
	"./components/popShare.vue": 52891,
	"./components/popSign": 65479,
	"./components/popSign.vue": 65479,
	"./components/popSpecialDetail": 4453,
	"./components/popSpecialDetail.vue": 4453,
	"./components/popSquad": 72994,
	"./components/popSquad.vue": 72994,
	"./components/popStarDeposit": 48478,
	"./components/popStarDeposit.vue": 48478,
	"./components/popTipEnergy": 14014,
	"./components/popTipEnergy.vue": 14014,
	"./components/popTipTaskDetail": 83483,
	"./components/popTipTaskDetail.vue": 83483,
	"./components/popUpGold": 25013,
	"./components/popUpGold.vue": 25013,
	"./components/popWithdraw": 780,
	"./components/popWithdraw.vue": 780,
	"./components/popYoutube": 7101,
	"./components/popYoutube.vue": 7101,
	"./components/preloadImage": 37532,
	"./components/preloadImage.vue": 37532,
	"./components/roundLoading/roundLoading": 55967,
	"./components/roundLoading/roundLoading.vue": 55967,
	"./components/starExplosion": 88046,
	"./components/starExplosion.vue": 88046,
	"./components/svgIcon": 43234,
	"./components/svgIcon.vue": 43234,
	"./components/tapcoinNew/danmaku/danMaku": 17622,
	"./components/tapcoinNew/danmaku/danMaku.vue": 17622,
	"./components/tapcoinNew/danmaku/mDanmaku": 76484,
	"./components/tapcoinNew/danmaku/mDanmaku.vue": 76484,
	"./components/tapcoinNew/nCurrency": 62459,
	"./components/tapcoinNew/nCurrency.vue": 62459,
	"./components/tapcoinNew/nCurrencyTwo": 65782,
	"./components/tapcoinNew/nCurrencyTwo.vue": 65782,
	"./components/tapcoinNew/nGiftHead": 63524,
	"./components/tapcoinNew/nGiftHead.vue": 63524,
	"./components/tapcoinNew/nHead": 77137,
	"./components/tapcoinNew/nHead.vue": 77137,
	"./components/tapcoinNew/nMenu": 32277,
	"./components/tapcoinNew/nMenu.vue": 32277,
	"./components/tapcoinNew/nNewHead": 67838,
	"./components/tapcoinNew/nNewHead.vue": 67838,
	"./components/tapcoinNew/popDoubleReward": 87049,
	"./components/tapcoinNew/popDoubleReward.vue": 87049,
	"./components/tapcoinNew/popFail": 50478,
	"./components/tapcoinNew/popFail.vue": 50478,
	"./components/tapcoinNew/popLockAvatar": 20172,
	"./components/tapcoinNew/popLockAvatar.vue": 20172,
	"./components/tapcoinNew/popRewardResultM": 542,
	"./components/tapcoinNew/popRewardResultM.vue": 542,
	"./components/tapcoinNew/slotMachine/mGift": 25631,
	"./components/tapcoinNew/slotMachine/mGift.vue": 25631,
	"./components/tapcoinNew/slotMachine/mSlotMachine": 89435,
	"./components/tapcoinNew/slotMachine/mSlotMachine.vue": 89435,
	"./components/uMenu": 53514,
	"./components/uMenu.vue": 53514,
	"./config": 6846,
	"./config/": 6846,
	"./config/index": 6846,
	"./config/index.js": 6846,
	"./directive": 90973,
	"./directive/": 90973,
	"./directive/direct/v-anchor": 52828,
	"./directive/direct/v-anchor.js": 52828,
	"./directive/direct/v-copy": 44404,
	"./directive/direct/v-copy.js": 44404,
	"./directive/direct/v-debounce": 64459,
	"./directive/direct/v-debounce.js": 64459,
	"./directive/direct/v-draggable": 52971,
	"./directive/direct/v-draggable.js": 52971,
	"./directive/direct/v-scroll": 57660,
	"./directive/direct/v-scroll.js": 57660,
	"./directive/direct/v-shuibowen": 73131,
	"./directive/direct/v-shuibowen.js": 73131,
	"./directive/index": 90973,
	"./directive/index.js": 90973,
	"./http": 11063,
	"./http/": 11063,
	"./http/index": 11063,
	"./http/index.js": 11063,
	"./i18n": 86926,
	"./i18n/": 86926,
	"./i18n/i18nOption": 17292,
	"./i18n/i18nOption.json": 17292,
	"./i18n/index": 86926,
	"./i18n/index.js": 86926,
	"./i18n/json/Chs": 15077,
	"./i18n/json/Chs.json": 15077,
	"./i18n/json/En": 74030,
	"./i18n/json/En.json": 74030,
	"./main": 43217,
	"./main.js": 43217,
	"./mixins/anim": 82568,
	"./mixins/anim.js": 82568,
	"./router": 15092,
	"./router/": 15092,
	"./router/index": 15092,
	"./router/index.js": 15092,
	"./store": 68854,
	"./store/": 68854,
	"./store/index": 68854,
	"./store/index.js": 68854,
	"./store/modules/achievements": 73232,
	"./store/modules/achievements.js": 73232,
	"./store/modules/airdrop": 28913,
	"./store/modules/airdrop.js": 28913,
	"./store/modules/appcenter": 25282,
	"./store/modules/appcenter.js": 25282,
	"./store/modules/assets": 91407,
	"./store/modules/assets.js": 91407,
	"./store/modules/autobot": 54855,
	"./store/modules/autobot.js": 54855,
	"./store/modules/bioMatrixScan": 64335,
	"./store/modules/bioMatrixScan.js": 64335,
	"./store/modules/daily": 51572,
	"./store/modules/daily.js": 51572,
	"./store/modules/deposit": 22881,
	"./store/modules/deposit.js": 22881,
	"./store/modules/lottery": 43136,
	"./store/modules/lottery.js": 43136,
	"./store/modules/lucky": 30457,
	"./store/modules/lucky.js": 30457,
	"./store/modules/luckybox": 54573,
	"./store/modules/luckybox.js": 54573,
	"./store/modules/mine": 40821,
	"./store/modules/mine.js": 40821,
	"./store/modules/ranking": 51734,
	"./store/modules/ranking.js": 51734,
	"./store/modules/squad": 20849,
	"./store/modules/squad.js": 20849,
	"./store/modules/task": 72390,
	"./store/modules/task.js": 72390,
	"./store/modules/user": 69220,
	"./store/modules/user.js": 69220,
	"./store/modules/wallet": 9944,
	"./store/modules/wallet.js": 9944,
	"./tonWallet": 88929,
	"./tonWallet/": 88929,
	"./tonWallet/index": 88929,
	"./tonWallet/index.js": 88929,
	"./utils": 1474,
	"./utils/": 1474,
	"./utils/errcode": 48956,
	"./utils/errcode.js": 48956,
	"./utils/errcode302": 22667,
	"./utils/errcode302.js": 22667,
	"./utils/formatter": 83291,
	"./utils/formatter.js": 83291,
	"./utils/index": 1474,
	"./utils/index.js": 1474,
	"./view": 65581,
	"./view/": 65581,
	"./view/BioMatrix": 96102,
	"./view/BioMatrix.vue": 96102,
	"./view/CodexFieldWallet": 13618,
	"./view/CodexFieldWallet.vue": 13618,
	"./view/DailyInvite": 88032,
	"./view/DailyInvite.vue": 88032,
	"./view/achievements": 26764,
	"./view/achievements.vue": 26764,
	"./view/activity": 53906,
	"./view/activity.vue": 53906,
	"./view/airdrop": 58615,
	"./view/airdrop.vue": 58615,
	"./view/airdropFirst": 83827,
	"./view/airdropFirst.vue": 83827,
	"./view/airdropInviter": 72000,
	"./view/airdropInviter.vue": 72000,
	"./view/airdropReward": 26469,
	"./view/airdropReward.vue": 26469,
	"./view/airdropSecond": 20348,
	"./view/airdropSecond.vue": 20348,
	"./view/appcenter": 1675,
	"./view/appcenter.vue": 1675,
	"./view/avatar": 61836,
	"./view/avatar.vue": 61836,
	"./view/bioMatrixScan": 86899,
	"./view/bioMatrixScan.vue": 86899,
	"./view/bioMatrixScanDetail": 51051,
	"./view/bioMatrixScanDetail.vue": 51051,
	"./view/bioMatrixScanInvite": 85852,
	"./view/bioMatrixScanInvite.vue": 85852,
	"./view/bitgetWallet": 55724,
	"./view/bitgetWallet.vue": 55724,
	"./view/bitgetWalletAirdrop": 26714,
	"./view/bitgetWalletAirdrop.vue": 26714,
	"./view/blind": 93211,
	"./view/blind.vue": 93211,
	"./view/boost": 17685,
	"./view/boost.vue": 17685,
	"./view/code": 3226,
	"./view/code.vue": 3226,
	"./view/depositDetail": 27286,
	"./view/depositDetail.vue": 27286,
	"./view/earn": 10158,
	"./view/earn.vue": 10158,
	"./view/frens": 62880,
	"./view/frens.vue": 62880,
	"./view/giftInventory": 24012,
	"./view/giftInventory.vue": 24012,
	"./view/gifts": 31306,
	"./view/gifts.vue": 31306,
	"./view/index": 65581,
	"./view/index.vue": 65581,
	"./view/join": 69919,
	"./view/join.vue": 69919,
	"./view/lottery": 18733,
	"./view/lottery.vue": 18733,
	"./view/lotteryDetail": 3367,
	"./view/lotteryDetail.vue": 3367,
	"./view/lucky": 87287,
	"./view/lucky.vue": 87287,
	"./view/luckyBox": 44530,
	"./view/luckyBox.vue": 44530,
	"./view/luckyBoxNew": 71024,
	"./view/luckyBoxNew.vue": 71024,
	"./view/mine": 50268,
	"./view/mine.vue": 50268,
	"./view/nft": 7450,
	"./view/nft.vue": 7450,
	"./view/nftLucky": 65350,
	"./view/nftLucky.vue": 65350,
	"./view/okxWallet": 84128,
	"./view/okxWallet.vue": 84128,
	"./view/pph": 84051,
	"./view/pph.vue": 84051,
	"./view/rank": 59825,
	"./view/rank.vue": 59825,
	"./view/sign": 29738,
	"./view/sign.vue": 29738,
	"./view/slotMachine": 70878,
	"./view/slotMachine.vue": 70878,
	"./view/solojack": 10945,
	"./view/solojack.vue": 10945,
	"./view/squad": 85445,
	"./view/squad.vue": 85445,
	"./view/taskDetail": 48277,
	"./view/taskDetail.vue": 48277,
	"./view/wallet": 82102,
	"./view/wallet.vue": 82102,
	"./view/walletDetail": 35118,
	"./view/walletDetail.vue": 35118,
	"./view/withdraw": 22803,
	"./view/withdraw.vue": 22803,
	"./view/youtube": 36428,
	"./view/youtube.vue": 36428,
	"./web3Wallet": 79305,
	"./web3Wallet/": 79305,
	"./web3Wallet/config/config": 7935,
	"./web3Wallet/config/config.json": 7935,
	"./web3Wallet/config_for_test/config": 94175,
	"./web3Wallet/config_for_test/config.json": 94175,
	"./web3Wallet/contracts/market": 37496,
	"./web3Wallet/contracts/market.json": 37496,
	"./web3Wallet/contracts/market_old": 64409,
	"./web3Wallet/contracts/market_old.json": 64409,
	"./web3Wallet/contracts_for_test/market": 30551,
	"./web3Wallet/contracts_for_test/market.json": 30551,
	"./web3Wallet/contracts_for_test/market_old": 4076,
	"./web3Wallet/contracts_for_test/market_old.json": 4076,
	"./web3Wallet/index": 79305,
	"./web3Wallet/index.js": 79305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;